import { Outlet } from 'react-router'
import { EnhancedProjectLayout } from '#app/components/layouts/EnhancedProjectLayout'

export default function SettingsLayout() {
  return (
    <EnhancedProjectLayout>
      <Outlet />
    </EnhancedProjectLayout>
  )
}